import _toConsumableArray from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import { QuestionType } from '../question-type';
import { isNoneLinkedEntityId, linkedEntityIdsEqual, normalizeLinkedEntityId } from '../heading';
export var QuestionReleases = /*#__PURE__*/function () {
  function QuestionReleases() {
    _classCallCheck(this, QuestionReleases);
  }

  _createClass(QuestionReleases, null, [{
    key: "getQuestionWeight",
    value: function getQuestionWeight(question) {
      switch (question.type) {
        case QuestionType.FillInBlank:
          {
            var _fillInBlankQuestion$, _fillInBlankQuestion$2;

            var fillInBlankQuestion = question;
            return ((_fillInBlankQuestion$ = fillInBlankQuestion.answers) === null || _fillInBlankQuestion$ === void 0 ? void 0 : _fillInBlankQuestion$.length) || ((_fillInBlankQuestion$2 = fillInBlankQuestion.correctAnswers) === null || _fillInBlankQuestion$2 === void 0 ? void 0 : _fillInBlankQuestion$2.length) || 1;
          }

        case QuestionType.Matching:
          {
            var _matchingQuestion$sub, _matchingQuestion$cor;

            var matchingQuestion = question;
            return ((_matchingQuestion$sub = matchingQuestion.subQuestions) === null || _matchingQuestion$sub === void 0 ? void 0 : _matchingQuestion$sub.length) || ((_matchingQuestion$cor = matchingQuestion.correctAnswers) === null || _matchingQuestion$cor === void 0 ? void 0 : _matchingQuestion$cor.length) || 1;
          }

        default:
          return 1;
      }
    }
  }, {
    key: "addIndex",
    value: function addIndex(questions) {
      if (!questions || questions.length === 0) {
        return [];
      }

      return questions.map(function (q, index) {
        var _questions;

        var idx = ((_questions = questions[index - 1]) === null || _questions === void 0 ? void 0 : _questions.nextIndex) || 1;

        if (q.type === QuestionType.FillInBlank) {
          var question = q;
          question.addIndex(idx);
          question.addNextIndex(idx + question.answers.length);
          return question;
        } else if (q.type === QuestionType.Matching) {
          var _question = q;

          _question.addIndex(idx);

          _question.addNextIndex(idx + _question.subQuestions.length);

          return _question;
        } else {
          q.addIndex(idx);
          q.addNextIndex(idx + 1);
          return q;
        }
      });
    }
  }, {
    key: "ignoreCorrectAnswers",
    value: function ignoreCorrectAnswers(questions) {
      if (!questions || questions.length === 0) {
        return [];
      }

      return questions.map(function (q) {
        return q.clone(false, false);
      });
    }
  }, {
    key: "sortQuestionsWithIndexAndSection",
    value: function sortQuestionsWithIndexAndSection(questions) {
      var _this = this;

      if (!questions || questions.length === 0) {
        return [];
      }

      var mapSections = new Map(); // eslint-disable-next-line no-loops/no-loops

      var _iterator = _createForOfIteratorHelper(questions),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _question2 = _step.value;

          var sectionId = _question2.sectionId.toString();

          if (mapSections.has(sectionId)) {
            mapSections.get(sectionId).push(_question2);
          } else {
            mapSections.set(sectionId, [_question2]);
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      var sortedQuestions = [];
      mapSections.forEach(function (value) {
        sortedQuestions.push.apply(sortedQuestions, _toConsumableArray(_this.sortQuestions(value)));
      });
      var weightOfIndex = 1;
      var newSortedQuestions = [];

      for (var index = 0; index < sortedQuestions.length; index++) {
        var question = sortedQuestions[index];
        var weight = this.getQuestionWeight(question);
        question.addIndex(weightOfIndex);
        question.addNextIndex(weightOfIndex + weight);
        weightOfIndex += weight;
        newSortedQuestions.push(question);
      }

      return newSortedQuestions;
    }
  }, {
    key: "sortQuestionsByLinkedList",
    value: function sortQuestionsByLinkedList(questions) {
      if (!questions || questions.length === 0) {
        return [];
      }

      if (questions.length === 1) {
        return questions;
      }

      var sortedQuestions = [];
      var usedIds = new Set();
      var headQuestion = questions.find(function (question) {
        return isNoneLinkedEntityId(question.previousQuestionId);
      });

      if (headQuestion) {
        sortedQuestions.push(headQuestion);
        usedIds.add(headQuestion.id.toString());
      }

      var currentQuestionId = headQuestion ? normalizeLinkedEntityId(headQuestion.id.toString()) : undefined;
      questions.forEach(function () {
        if (!currentQuestionId) {
          return;
        }

        var nextQuestion = questions.find(function (question) {
          return linkedEntityIdsEqual(question.previousQuestionId, currentQuestionId) && !usedIds.has(question.id.toString());
        });

        if (!nextQuestion) {
          return;
        }

        sortedQuestions.push(nextQuestion);
        usedIds.add(nextQuestion.id.toString());
        currentQuestionId = normalizeLinkedEntityId(nextQuestion.id.toString());
      });
      questions.forEach(function (question) {
        var id = question.id.toString();

        if (!usedIds.has(id)) {
          sortedQuestions.push(question);
          usedIds.add(id);
        }
      });
      return sortedQuestions;
    }
  }, {
    key: "sortQuestions",
    value: function sortQuestions(questions) {
      var _this2 = this;

      if (!questions || questions.length === 0) {
        return [];
      }

      var mapSections = questions.reduce(function (map, question) {
        var sectionId = question.sectionId.toString();

        if (!map.has(sectionId)) {
          map.set(sectionId, []);
        }

        map.get(sectionId).push(question);
        return map;
      }, new Map());
      return Array.from(mapSections.values()).flatMap(function (sectionQuestions) {
        return _this2.addIndex(_this2.sortQuestionsByLinkedList(sectionQuestions));
      });
    }
  }, {
    key: "indexAllQuestions",
    value: function indexAllQuestions(questions) {
      var _this3 = this;

      if (!questions || questions.length === 0) {
        return [];
      }

      var mapSections = new Map(); // eslint-disable-next-line no-loops/no-loops

      var _iterator2 = _createForOfIteratorHelper(questions),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var question = _step2.value;
          var sectionId = question.sectionId.toString();

          if (mapSections.has(sectionId)) {
            mapSections.get(sectionId).push(question);
          } else {
            mapSections.set(sectionId, [question]);
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }

      var sortedQuestions = [];
      mapSections.forEach(function (value) {
        sortedQuestions.push.apply(sortedQuestions, _toConsumableArray(_this3.sortQuestions(value)));
      });
      return sortedQuestions;
    }
  }, {
    key: "totalQuestions",
    value: function totalQuestions(questions) {
      var _this4 = this;

      if (!(questions !== null && questions !== void 0 && questions.length)) {
        return 0;
      }

      return questions.reduce(function (total, question) {
        return total + _this4.getQuestionWeight(question);
      }, 0);
    }
  }, {
    key: "totalQuestionsBySection",
    value: function totalQuestionsBySection(questions, sectionId) {
      var questionsBySection = questions && questions.length > 0 && questions.filter(function (q) {
        return q.sectionId === sectionId;
      });
      return this.totalQuestions(questionsBySection);
    }
  }, {
    key: "calculateMaxTotalScore",
    value: function calculateMaxTotalScore(questions) {
      if (!questions || questions.length === 0) {
        return 0;
      }

      return questions.reduce(function (total, question) {
        return total + question.score;
      }, 0);
    }
  }, {
    key: "orderQuestionsBySections",
    value: function orderQuestionsBySections(questions, sectionSummaries) {
      var _this5 = this;

      // Keep the same order used by section summary UI ("Section 1", "Section 2", ...),
      // which is the sectionSummaries array order — not a re-sort that can reverse indices.
      var sortedQuestions = [];
      var usedQuestionIds = new Set();
      sectionSummaries.forEach(function (section) {
        var sectionId = section.id.toString();
        var questionsInSection = questions.filter(function (q) {
          var _q$sectionId;

          return ((_q$sectionId = q.sectionId) === null || _q$sectionId === void 0 ? void 0 : _q$sectionId.toString()) === sectionId;
        });

        var orderedQuestions = _this5.sortQuestionsByLinkedList(questionsInSection);

        orderedQuestions.forEach(function (question) {
          sortedQuestions.push(question);
          usedQuestionIds.add(question.id.toString());
        });
      }); // Keep any questions that did not match a section so indexing still runs

      questions.forEach(function (question) {
        if (!usedQuestionIds.has(question.id.toString())) {
          sortedQuestions.push(question);
        }
      });
      return sortedQuestions;
    }
  }, {
    key: "sortQuestionsBySectionsOrder",
    value: function sortQuestionsBySectionsOrder(questions, sectionSummaries) {
      var _this6 = this;

      if (!questions || questions.length === 0) {
        return [];
      }

      if (!sectionSummaries || sectionSummaries.length === 0) {
        return this.sortQuestions(questions);
      }

      var sortedQuestions = [];
      var usedQuestionIds = new Set(); // Match section summary UI order (array order = Section 1, 2, 3...)

      sectionSummaries.forEach(function (section) {
        var sectionId = section.id.toString();
        var questionsInSection = questions.filter(function (q) {
          var _q$sectionId2;

          return ((_q$sectionId2 = q.sectionId) === null || _q$sectionId2 === void 0 ? void 0 : _q$sectionId2.toString()) === sectionId;
        });

        var indexedSectionQuestions = _this6.sortQuestions(questionsInSection);

        indexedSectionQuestions.forEach(function (question) {
          sortedQuestions.push(question);
          usedQuestionIds.add(question.id.toString());
        });
      });
      var orphanQuestions = questions.filter(function (q) {
        return !usedQuestionIds.has(q.id.toString());
      });

      if (orphanQuestions.length > 0) {
        sortedQuestions.push.apply(sortedQuestions, _toConsumableArray(this.sortQuestions(orphanQuestions)));
      }

      return sortedQuestions;
    }
    /**
     * Orders questions by section order and assigns continuous indices across sections
     * (e.g. Section1: 1-4, Section2: 5-9), including multi-slot FIB/Matching weights.
     */

  }, {
    key: "sortQuestionsWithIndexBySectionsOrder",
    value: function sortQuestionsWithIndexBySectionsOrder(questions, sectionSummaries) {
      if (!questions || questions.length === 0) {
        return [];
      }

      if (!sectionSummaries || sectionSummaries.length === 0) {
        return this.sortQuestionsWithIndexAndSection(questions);
      }

      var sortedQuestions = this.orderQuestionsBySections(questions, sectionSummaries);
      return this.sortQuestionsWithIndexAndSection(sortedQuestions);
    }
    /**
     * Builds a map of questionId -> continuous display index across sections
     * without relying on mutating question.index (safe for Redux state).
     */

  }, {
    key: "getContinuousQuestionIndexes",
    value: function getContinuousQuestionIndexes(questions, sectionSummaries) {
      var _this7 = this;

      var indexByQuestionId = new Map();

      if (!questions || questions.length === 0) {
        return indexByQuestionId;
      }

      var orderedQuestions = sectionSummaries && sectionSummaries.length > 0 ? this.orderQuestionsBySections(questions, sectionSummaries) : _toConsumableArray(questions).sort(function (a, b) {
        var _a$index, _b$index;

        return ((_a$index = a.index) !== null && _a$index !== void 0 ? _a$index : 0) - ((_b$index = b.index) !== null && _b$index !== void 0 ? _b$index : 0);
      });
      var nextIndex = 1;
      orderedQuestions.forEach(function (question) {
        indexByQuestionId.set(question.id.toString(), nextIndex);
        nextIndex += _this7.getQuestionWeight(question);
      });
      return indexByQuestionId;
    }
  }, {
    key: "getContinuousQuestionIndexesInDisplayOrder",
    value: function getContinuousQuestionIndexesInDisplayOrder(questions, sectionSummaries) {
      var _this8 = this;

      var indexByQuestionId = new Map();

      if (!questions || questions.length === 0) {
        return indexByQuestionId;
      }

      var questionIdsInSections = new Set();
      var orderedQuestions = (sectionSummaries || []).flatMap(function (section) {
        var sectionId = section.id.toString();
        return questions.filter(function (question) {
          var _question$sectionId;

          var belongsToSection = ((_question$sectionId = question.sectionId) === null || _question$sectionId === void 0 ? void 0 : _question$sectionId.toString()) === sectionId;

          if (belongsToSection) {
            questionIdsInSections.add(question.id.toString());
          }

          return belongsToSection;
        });
      });
      orderedQuestions.push.apply(orderedQuestions, _toConsumableArray(questions.filter(function (question) {
        return !questionIdsInSections.has(question.id.toString());
      })));
      var nextIndex = 1;
      orderedQuestions.forEach(function (question) {
        indexByQuestionId.set(question.id.toString(), nextIndex);
        nextIndex += _this8.getQuestionWeight(question);
      });
      return indexByQuestionId;
    }
  }]);

  return QuestionReleases;
}();